import { render, staticRenderFns } from "./g_card.vue?vue&type=template&id=4ef8b207&"
import script from "./g_card.vue?vue&type=script&lang=js&"
export * from "./g_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports